<template>
  <div id="app" v-cloak>
    <Navbar />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
// import store from "@/store.js";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: { Navbar, Footer },
  methods: {},
  data() {
    return {};
  },
  mounted() {
    document.body.style.overflowY = "scroll";
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;600&display=swap");

[v-cloak] {
  display: none;
}

#app {
  font-family: "Oswald", sans-serif;

  h1 {
    font-weight: 600;
  }
  h3 {
    text-shadow: 1px 1px lightgrey;
  }
  .z-10 {
    z-index: 10;
  }
  .main-theme {
    color: #e81b29;
    a {
      color: #e81b29;
    }
  }
  .text-theme {
    color: #777777;
  }
  .content-top-padding {
    padding-top: 80px;
  }
  .padding-for-footer {
    padding-bottom: 75px;
  }
  .route-arrow {
    width: 28px;
  }
  // .routing {
  // text-shadow: 1px 1px lightgrey;
  // }
  @media (max-width: 450px) {
    .custom-breadcrumb {
      font-size: 4vw;
    }
  }
  @media (max-width: 575px) {
    .route-arrow {
      width: 4.2vw;
    }
  }
}
.initiatives {
  .partner-icon {
    img {
      width: 100%;
    }
  }
  .initiatives-nav {
    background-color: #f5dbdf;
  }
  .second-nav-bg {
    background-color: #e81b29;
  }
  .nav-thumbnail {
    text-align: center;
  }
  .nav-desc {
    color: #fff;
    text-align: center;
  }
  .banner {
    img {
      width: 100%;
    }
  }
  .nav-item {
    a {
      padding: 1.8rem;
      color: #e81b29;
    }
    .active {
      background-color: #e81b29;
      color: #fff;
    }
  }
  .carou-slide {
    text-align: -webkit-center;
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .carousel-control-prev,
  .carousel-control-next {
    opacity: 1;
    background-image: none;
    width: 10%;
  }
  .carousel-control-next-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23e81b29' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
  }
  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23e81b29' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
  }
  .cool-lightbox__slide__img {
    max-width: 80vw;
  }
  .intro {
    border-bottom: 1px solid rgb(200, 200, 200);
    img {
      width: 100%;
    }
  }
  .text-theme {
    text-align: justify;
  }
  .foot-note {
    background-color: #eaeaea;
    .title {
      color: rgb(80, 80, 80);
    }
    .dot-points {
      font-size: 0.9rem;
      li {
        margin-bottom: 0.4rem;
      }
    }
  }
  @media (max-width: 450px) {
    .foot-note {
      .dot-points {
        ul {
          padding-left: 0.5rem;
        }
      }
    }
  }
}
.page-selector {
  .custom-select {
    border: 3px solid #e81b29;
    border-radius: 0;
    padding-top: 2px;
    padding-bottom: 2px;
    color: #e81b29;
  }
}
.custom-select {
  background: url(./assets/01/arrow_lower.svg) right 0.75rem center/15px no-repeat !important;
}
@media (max-width: 767px) {
  .second-nav {
    display: none;
  }
}
</style>
